import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'source', 'copyIcon', 'successIcon', 'buttonText']
  static values = {
    successDuration: {
      type: Number,
      default: 2000
    }
  }

  connect() {
    if (!this.hasButtonTarget) return

    this.originalText = this.buttonTextTarget.innerText
  }

  copy(event) {
    event.preventDefault()

    navigator.clipboard.writeText(this.sourceTarget.innerText).then(() => this.copied())
  }

  copied() {
    if (!this.hasButtonTarget) return

    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.copyIconTarget.classList.add('hidden')
    this.successIconTarget.classList.remove('hidden')
    this.buttonTextTarget.innerText = this.data.get('successContent')

    this.timeout = setTimeout(() => {
      this.buttonTextTarget.innerText = this.originalText
      this.copyIconTarget.classList.remove('hidden')
      this.successIconTarget.classList.add('hidden')
    }, this.successDurationValue)
  }
}
